import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const faqData = [
  {
    q: "Can we do children?",
    a: "At this time No, but maybe in the future."
  },
  {
    q: "Can we do bedbound people?",
    a: "The answer is yes. My home visiting kit is complete with fully portable table and extension lead. All I'll need from you is access to a plug socket and some warm water."
  },
  {
    q: "Do I have to be housebound to get a home visit?",
    a: "No, if you would rather we come to you we can. There is a price difference though."
  },
  {
    q: "Does it hurt?",
    a: "No, it's can be noisy and tickling sensation, but if you have followed the pre treatment advice, it shouldn't be painful."
  },
  {
    q: "When do I pay and how?",
    a: "No payment is taken until examinations & treatment has been completed. We take Cash, Card payment or bank transfer, whichever is easiest for you. You will receive a receipt via email."
  },
  {
    q: "Do I need to prepare before my appointment?",
    a: "You will receive a confirmation email with an attached consent form to be completed and advise to use medicinal olive oil or extra Virginia olive oil or almond oil as alternatives."
  },
  {
    q: "How often should ear wax be removed?",
    a: "There are no set rule. Simplell answer is as often as the wax builds up and causes problems."
  },
  {
    q: "Can ear wax come back?",
    a: "Yes. Ear wax is natural and can build up again over time. Regular check-ups may help if you’re prone to blockage."
  },
  {
    q: "What is ear wax?",
    a: "Ear wax (cerumen) is a natural substance produced by glands in the ear canal. It helps protect the ear by trapping dust, debris, and bacteria, and usually moves out of the ear on its own."
  },
  {
    q: "When does ear wax become a problem?",
    a: "Ear wax can cause issues when it builds up and becomes impacted. This may lead to: Reduced or muffled hearing, Earache or discomfort, Tinnitus (ringing in the ear), Dizziness, A feeling of fullness or blockage."
  },
  {
    q: "What causes ear wax build-up?",
    a: "Common causes include: Using cotton buds or other objects in the ear, Wearing hearing aids or earplugs, Naturally narrow or curved ear canals, Overproduction of ear wax."
  },
  {
    q: "Is it safe to remove ear wax at home?",
    a: "You should not put objects (like cotton buds, hairpins, or candles) into your ears. These can push wax deeper or damage the ear. Softening drops may help in mild cases, but professional removal is recommended for blockage or symptoms."
  }
];

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-100 last:border-0">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-4 px-2 flex justify-between items-center text-left hover:bg-gray-50 transition-colors rounded-lg"
      >
        <span className="font-semibold text-gray-800 pr-4">{question}</span>
        <span className={`text-rose-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
          <SafeIcon icon={FiIcons.FiChevronDown} />
        </span>
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`}
      >
        <p className="text-gray-600 text-sm leading-relaxed px-2">{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">Frequently Asked Questions</h2>
          <p className="text-gray-500 mt-2">Everything you need to know about our service</p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8">
          {faqData.map((item, idx) => (
            <FAQItem key={idx} question={item.q} answer={item.a} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;